import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const WindowWPadding = (props: Icon): React.ReactElement => {
  const [uniqueId] = React.useState(Math.floor(Math.random() * 10000));

  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M19.333 18.667H4.667c-.367 0-.667.3-.667.666 0 .367.3.667.667.667h14.666c.367 0 .667-.3.667-.667 0-.366-.3-.666-.667-.666zM18.667 4H5.333v13.333h13.334V4zm-7.334 11.333h-4v-4h4v4zm0-5.333h-4V6h4v4zm5.334 5.333h-4v-4h4v4zm0-5.333h-4V6h4v4z"
          id={`window_w_padding_a_${uniqueId}`}
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id={`window_w_padding_b_${uniqueId}`} fill="#fff">
          <use xlinkHref={`#window_w_padding_a_${uniqueId}`} />
        </mask>
        <use
          fill="#FFF"
          fillRule="nonzero"
          xlinkHref={`#window_w_padding_a_${uniqueId}`}
        />
        <g
          mask={`url(#window_w_padding_b_${uniqueId})`}
          fill={props.color || theme.palette.grey800}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
};
